import { JarvisAuthPages, useDynamicConfig } from "@dgs/core";
import { FC } from "react";

export const PersonalManagerAuthPages: FC = () => {
	const { authUrl } = useDynamicConfig();

	return <JarvisAuthPages authUrl={authUrl} identityProvidersUrl={`${authUrl}/providers`} showPasswordReset={true} />;
};
